module.exports = __webpack_public_path__ + "static/media/building1.e127b5f3.svg";